import { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from "react-router-dom";
import { useAppContext } from '../config/context';
import { Ul } from "../Components/Ul";
import { checkAuth, logout } from '../Utils/auth';
import { apiCall } from '../Utils/api';
import TransLink from "../Components/TransLink";

export const Header = ({ home }) => {
    const [isOpened, setIsOpened] = useState(false);
    const [isAccountMenu, setAccountMenu] = useState(false);
    const [submitting, setSubmiting] = useState(false);
    const [scrollPosition, setScrollPosition] = useState(0);
    const { lang, setLang, app, setApp, isAuth, setAuth } = useAppContext();
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const prefix = lang === "es" ? "" : `/${lang}`;
    const isProperties = location.pathname === `/${prefix}/${t("url.properties")}`;
    const isNews = location.pathname.includes(`/${t("url.news")}`);
    const [loading, setLoading] = useState(true);
    const handleOpen = () => {
        setIsOpened(!isOpened);
    }

    const handleScroll = () => {
        const position = window.pageYOffset;
        setScrollPosition(position);
    };

    const handleChangeLang = (e, lang) => {
        setLang(lang);
    }

    const getAccountMenu = () => {
        if (!app.blocks[t('vars.account-menu', { lng: lang })]) {
            apiCall(`${process.env.REACT_APP_API_URL}/es/configuration?var=${t('vars.account-menu', { lng: lang })}`, 'get').then(res => {
                app.blocks[t('vars.account-menu', { lng: lang })] = res.value;
                setApp(app);
                setLoading(false);
            });
        }
    }

    useEffect(() => {
        if (sessionStorage.getItem('reload')) {
            sessionStorage.removeItem('reload');
        }
        checkAuth().then(res => {
            if (res) {
                setAuth(true);
            } else {
                setAuth(false);
            }
        });
        if (loading) {
            getAccountMenu()
        }
    }, []);

    useEffect(() => {
        if (i18n.language !== lang) {
            getAccountMenu();
        }
    }, [lang]);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [scrollPosition]);

    useEffect(() => {
        setIsOpened(false);
        setAccountMenu(false);
    }, [location]);

    const handleLogout = async () => {
        setSubmiting(true);
        const res = await logout();
        if (res.status === "error") {
            alert(res.message);
        } else {
            setAuth(false);
            setAccountMenu(false);
        }
        setSubmiting(false);
    }

    const translateRoute = lng => {
        if (home) {
            return lng === "es" ? "/" : `/${lng}`;
        }
        if (isNews && app.newSlug) {
            return lng === "es" ? `/${t('url.news',{ lng: "lang" })}/${app.newSlug}` : `/${lng}/${t('url.news',{ lng: 'en' })}/${app.newSlugEn}`;
        }

        let route = location.pathname.split('/').filter(Boolean);

        if (["es", "en"].includes(route[0])) {
            route.shift();
        }

        route = route.map(r => {
            return i18n.exists(`url.${r}`, { lng })
                ? t(`url.${r}`, { lng })
                : r;
        });

        const path = `/${route.join('/')}`;

        if (lng === "es") {
            return path;
        }

        return `/${lng}${path}`;
    }


    const getHeaderClass = () => {
        if (!home && (!isProperties && !isNews)) {
            return "_301_alter_fix"
        }
        return ''
    }

    return (
        <header className={`${scrollPosition >= 10 ? '_301_active' : ''}`}>
            <div className={`_301_toolbar ${getHeaderClass()} ${scrollPosition >= 10 || isOpened ? '_301_alter' : ''}`}>
                <div className="_301_content _301_flex">
                    <div className="_301_col _301_account">
                        <div className="_301_option">
                            <div className="_301_icon" onClick={() => setAccountMenu(!isAccountMenu)}><i className="fa-solid fa-key"></i></div>
                            <label> {t('my-account')}  </label>
                            <div className={`_301_floating_block ${isAccountMenu ? '_301_active' : ''}`}>
                                {app.blocks[t('vars.account-menu', { lng: lang })] && <div dangerouslySetInnerHTML={{ __html: app.blocks[t('vars.account-menu', { lng: lang })] }} />}
                                {
                                    isAuth &&
                                    <>
                                        <div className="_301_row">
                                            <button className="_301_cta" disabled={submitting} onClick={handleLogout}>{t('logout')}</button>
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                        <a href="https://pagos.palomma.com/abadfaciolince/auth/login" target="_blank" rel="noreferrer">
                            <div className="_301_call_cta">
                                <i className="fa-solid fa-dollar"></i>
                                <label> {t('payment_link')}</label>

                            </div>
                        </a>
                    </div>
                    <div className="_301_col _301_brand">
                        <TransLink to="/">
                            <div className="_301_logo">
                            </div>
                        </TransLink>
                    </div>
                    <div className="_301_col _301_menu">
                        <TransLink to={t('url.favorites')}>
                            <div className="_301_call_cta _301_fav">
                                <i className="fa-solid fa-heart"></i>
                            </div>
                        </TransLink>
                        <div className="_301_option">
                            <label>{t('menu')} </label>
                            <div className={`_301_icon ${isOpened ? '_301_close' : ""}`} onClick={handleOpen}><i className="fa-solid fa-bars"></i><i className="fa-solid fa-xmark"></i></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`_301_menu_view ${isOpened ? '_301_show' : ""}`}>
                <div className="_301_content">
                    <div className="_301_category">
                        <Ul
                            head={t('company')}
                            options={[
                                {
                                    href: `${lang === "en" ? `/${lang}` : ""}/${t('url.about-us')}`,
                                    title: t("about-us"),
                                },
                                {
                                    href: `${lang === "en" ? `/${lang}` : ""}/${t('url.news')}`,
                                    title: t("news"),
                                },
                            ]}
                        />
                    </div>
                    <div className="_301_category">
                        <Ul
                            head={t('properties')}
                            options={[
                                {
                                    href: `${lang === "en" ? `/${lang}` : ""}/${t('url.how-to-rent')}`,
                                    title: t("how-to-rent"),
                                },
                                {
                                    href: `${lang === "en" ? `/${lang}` : ""}/${t('url.properties')}?property-status=rent`,
                                    title: t("rent"),
                                },
                                {
                                    href: `${lang === "en" ? `/${lang}` : ""}/${t('url.properties')}`,
                                    title: t('sell'),
                                },
                                {
                                    href: `${lang === "en" ? `/${lang}` : ""}/${t('url.properties')}?property-type=11`,
                                    title: t("projects"),
                                }
                            ]}
                        />
                    </div>
                    <div className="_301_category">
                        <Ul
                            head="Trámites"
                            options={[
                                {
                                    href: `${lang === "en" ? `/${lang}` : ""}/${t('url.postulate')}`,
                                    title: t("postulate")
                                },
                                {
                                    href: `${lang === "en" ? `/${lang}` : ""}/${t('url.contracts')}`,
                                    title: t("contracts")
                                },
                                {
                                    href: `${lang === "en" ? `/${lang}` : ""}/${t('url.repair')}`,
                                    title: t("repairs")
                                },
                                {
                                    href: "https://pagos.palomma.com/abadfaciolince/auth/login",
                                    title: t("online-payments"),
                                    external: true
                                },
                                {
                                    href: `${lang === "en" ? `/${lang}` : ""}/${t('url.pqr')}`,
                                    title: t("pqrs")
                                }
                            ]}
                        />
                    </div>
                    <div className="_301_category">
                        <h3>{t('lang')}</h3>
                        <ul className="_301_hover">
                            <li>
                                <Link to={translateRoute('es')} className={lang === "es" ? "_301_lang_active" : ""} onClick={e => handleChangeLang(e, 'es')}>Español</Link>
                            </li>
                            <li>
                                <Link to={translateRoute('en')} className={lang === "en" ? "_301_lang_active" : ""} onClick={e => handleChangeLang(e, 'en')}>English</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </header>
    );
}